exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-68905eea] [x-arrow] {\n  color: #15a5bb;\n  transition: color .2s ease-in-out;\n}\n[data-v-68905eea] .arrow-grey [x-arrow] {\n  color: #74787f;\n}\n[data-v-68905eea] .arrow-negative [x-arrow] {\n  color: #dc2626;\n}\n[data-v-68905eea] .arrow-neutral [x-arrow] {\n  color: #f59e0b;\n}\n[data-v-68905eea] .arrow-positive [x-arrow] {\n  color: #16a34a;\n}\n", ""]);

// exports
